import { EMPTY_VALUE_PLACEHOLDER } from '../const/system';



export const getValueOrPlaceholder = (value) => {
  return value ?? EMPTY_VALUE_PLACEHOLDER;
};
